// extracted by mini-css-extract-plugin
export default {"modalWrapper":"CheckResult_modalWrapper__Ie7zD","modalWrapper2":"CheckResult_modalWrapper2__b-W3H","loader":"CheckResult_loader__EJb+y","l3":"CheckResult_l3__hRsmE"};